import { render, staticRenderFns } from "./StudentDiscount.vue?vue&type=template&id=5511126a&"
import script from "./StudentDiscount.vue?vue&type=script&lang=js&"
export * from "./StudentDiscount.vue?vue&type=script&lang=js&"
import style0 from "./StudentDiscount.vue?vue&type=style&index=0&id=5511126a&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports